module.exports = __webpack_public_path__ + "img/空白（底图+页码+文字）.5c1a892e.png";